module.exports = __webpack_public_path__ + "static/img/bk_sea.4db64177.jpg";